module.exports = __webpack_public_path__ + "img/mealreminder-minip-small-white.8d5f0ea4.png";